<template>
    <form
        :action="action"
        class="c-form"
        :class="{ 'is-submitted' : success }"
        ref="$form"
        @submit="submit"
    >
        <div class="c-form__inner">
            <InputText
                v-for="field in fields"
                :key="field.name"
                :placeholder="field.placeholder"
                :required="field.required"
                :name="field.name"
                :type="field.type"
                class="c-form__el"
                :class="{ 'c-form__el--half' : field.half }"
            />

            <InputText
                ref="$honeypot"
                placeholder="Site internet"
                name="website"
                type="text"
                class="c-form__el | c-form__website"
            />

            <input
                ref="$csrf_token"
                name="csrf_token"
                type="hidden"
                value=""
            >

            <Btn
                label="Envoyer"
                type="submit"
                :large="true"
                class="c-form__submit"
            />
        </div>
        <div class="c-form__success">
            <h2 class="t-t3-serif | mb-4">Votre message a été envoyé avec succès&nbsp;!</h2>
            <p>Retourner à la <router-link to="/fr" title="Accueil" class="t-link">page d'accueil</router-link></p>
        </div>
    </form>
</template>

<script>/* eslint-disable */

    import Btn from 'components/Btn'
    import InputText from 'components/InputText'

    export default {
        name: 'Formular',
        components: {
            Btn,
            InputText
        },
        props: {
            action: {
                type: String
            },
            fields: {
                type: Array,
                default: () => []
            }
        },
        data: () => {
            return {
                success: false
            }
        },
        computed: {
            formFields() {
                return this.getFormFields();
            },
        },
        mounted() {
            this.createFormToken()
        },
        methods: {

            getFormFields() {
                const _form = this.$refs.$form;
                const fields = {};
                _form.querySelectorAll('[name]').forEach(function (field) {
                    fields[field.name] = field;
                });

                return fields
            },
            createFormToken() {

                const _ = this
                const token_request = new XMLHttpRequest()
                const request_path = '/actions/forms/gettoken'

                token_request.onreadystatechange = function() {

                    let token_fields = _.$refs.$csrf_token

                    if (this.status === 200 && this.readyState === 4) {

                        let token = JSON.parse(this.response).token
                        token_fields.value = token
                    }
                }

                token_request.open('GET', request_path)
                token_request.send()

            },
            handleErrors(response) {

                const _ = this
                const form = _.$refs.$form

                let errors = []

                for (var key in response) {

                    if (!response.hasOwnProperty(key))
                        continue

                    if (_.formFields.hasOwnProperty(key)) {
                        form[key].classList.add('has-error')
                        errors.push(response[key])
                    }
                }

                //message.innerHTML = errors.join('<br>');
            },
            submit(e) {
                e.preventDefault();

                const _ = this
                const request = new XMLHttpRequest();
                const request_path = e.target.action

                // Remove all 'error' classes of a possible previously failed validation.
                for ( var key in _.formFields ) {

                    if (!this.formFields.hasOwnProperty(key))
                        continue;

                    _.formFields[key].classList.remove('has-error')

                }

                request.onreadystatechange = function() {

                    if (this.status === 200 && this.readyState === 4) {
                        _.$refs.$form.classList.add('is-submitted')

                    } else if (this.status === 400 && this.readyState === 4) {
                        _.handleErrors( JSON.parse(this.response) )

                    }
                }

                request.open('POST', request_path);
                request.send(new FormData(e.target));
/*
                e.preventDefault()
                this.success = true
                this.$emit('submit')
*/
            }
        }
    }
</script>

<style lang="scss">

    .c-form {
        --spacing: .7em;

        &.is-submitted {

            .c-form__inner {
                opacity: 0;
                transform: translate(1em, 0) scale(.99, 1);
                transform-origin: 100% 50%;
                transition: all .2s $in-quad;
            }

            .c-form__success {
                pointer-events: initial;
                opacity: 1;
                transform: translate(0) scale(1);
                transition: all .4s $out-quad .2s;
            }
        }
    }

    .c-form__inner {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .c-form__el {
        width: 100%;
        margin-top: var(--spacing);
        margin-bottom: var(--spacing);

        &.c-form__website {
            position: absolute;
            left: -9999px;
        }

        @screen xs {

            &--half {
                width: calc(50% - var(--spacing));
            }
        }
    }

    .c-form__submit {
        margin-top: var(--spacing);
        margin-left: auto;
    }

    .c-form__success {
        position: absolute;
        bottom: 20%;
        left: 0;
        padding: 1.5em;
        background-color: $color-beige;
        border-radius: $radius;
        pointer-events: none;
        opacity: 0;
        transform: translate(-1em, 0) scale(.95, 1);
        transform-origin: 0 50%;
    }

</style>
